import * as React from "react";

export const useDebouncedEffect = (
  effect: (...args: any[]) => void,
  delay: number,
  deps: any[],
) => {
  const callback = React.useCallback(effect, deps);

  React.useEffect(() => {
    const handler = setTimeout(() => {
      callback();
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [callback, delay]);
};
